module.exports = __webpack_public_path__ + "img/Gallery_1_17.35684849.jpeg";